// @flow
import React from 'react';

import { useStarterCommitViolations } from '../../custom-hooks/useStarterCommitViolations';
import { NegativeMessageContainer } from '../presentational/messages/NegativeMessageContainer';
import { BulletedList } from '../presentational/lists/BulletedList';
import { CC_STARTER_COMMIT_VIOLATIONS_HEADER_TEXT } from '../../constants';

// The backend's messages state the problem and how to fix it; the consequence (Push to SFDC is
// blocked, also for admins) is the UI's to say, so it is added here as the heading.
export const StarterCommitViolationsContainer = () => {
  const violations = useStarterCommitViolations();

  if (violations.length === 0) {
    return null;
  }

  return (
    <NegativeMessageContainer
      body={<BulletedList items={violations.map((violation) => violation.message)} />}
      header={CC_STARTER_COMMIT_VIOLATIONS_HEADER_TEXT}
      // The list brings its own top margin, so no extra spacer is needed here
      headerToBodySpacing={0}
    />
  );
};
